import { createSlice } from '@reduxjs/toolkit';
import { getHomeData } from '../authActions';

export const homeDataSlice = createSlice({
    name: 'homeData',
    initialState: {
        data: {},
        error: '',
        loading: false
    },
    reducers: {
        clearHomeState: () => ({ data: {} })
    },
    extraReducers: {
        [getHomeData.pending]: (state) => ({
            ...state,
            error: '',
            loading: true
        }),
        [getHomeData.fulfilled]: (state, { payload }) => ({
            ...state,
            loading: false,
            data: payload.data
        }),
        [getHomeData.rejected]: (state, { payload }) => ({
            ...state,
            error: 'There was an error fetching home data',
            loading: false
        })
    }
});

export const { clearHomeState } = homeDataSlice.actions;
export default homeDataSlice.reducer;